import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { injectIntl } from 'react-intl';
import treeChanges from 'tree-changes';

import { Card, Collapse } from 'antd';
import CriteriaForm from './CriteriaForm';
import ReportTable from './ReportTable';

import LspSlsOrdTrackingReportActions from '../../Stores/LspSlsOrdTrackingReport/Actions';

const { Panel } = Collapse;

class LspSlsOrdTrackingReportScreen extends React.PureComponent {
  componentDidMount() {
    const { curSiteFlowId, initLspSlsOrdTracking } = this.props;

    if (curSiteFlowId > 0) {
      initLspSlsOrdTracking();
    }
  }

  componentDidUpdate(prevProps) {
    const { curSiteFlowId, initLspSlsOrdTracking } = this.props;
    const { changed } = treeChanges(prevProps, this.props);

    if (changed('curSiteFlowId')) {
      if (curSiteFlowId > 0) {
        initLspSlsOrdTracking();
      }
    }
  }

  componentWillUnmount() {}

  render() {
    const { intl, match } = this.props;

    return (
      <Card title={intl.formatMessage({ id: 'sales_order_tracking' })}>
        <Collapse defaultActiveKey={['2']}>
          <Panel header={intl.formatMessage({ id: 'criteria' })} key="1">
            <CriteriaForm match={match} />
          </Panel>
          <Panel header={intl.formatMessage({ id: 'report' })} key="2">
            <ReportTable match={match} />
          </Panel>
        </Collapse>
      </Card>
    );
  }
}

LspSlsOrdTrackingReportScreen.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  intl: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  match: PropTypes.object,

  initLspSlsOrdTracking: PropTypes.func,
  curSiteFlowId: PropTypes.number
};

LspSlsOrdTrackingReportScreen.defaultProps = {
  intl: {},
  match: {},

  initLspSlsOrdTracking: {},
  curSiteFlowId: 0
};

const mapStateToProps = state => ({
  curSiteFlowId: state.app.curSiteFlowId
});

const mapDispatchToProps = dispatch => ({
  initLspSlsOrdTracking: () =>
    dispatch(LspSlsOrdTrackingReportActions.lspSlsOrdTrackingReportInitLspSlsOrdTracking())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(LspSlsOrdTrackingReportScreen));
